import React, { useState } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../mock';

export default function FAQ() {
  return (
    <section className="section bg-neutral-50">
      <div className="container-x max-w-3xl">
        <div className="text-center mb-10">
          <div className="eyebrow">FAQ</div>
          <h2 className="section-title mt-3">Frequently Asked Questions</h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white rounded-2xl border border-neutral-100 px-5 shadow-sm"
            >
              <AccordionTrigger className="text-left font-semibold text-[color:var(--ink)] py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[color:var(--ink-soft)] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
